export default "__VITE_ASSET__fDczWROF__"